/* global google */
import GoogleMaps from '@utilities/google-maps'
import Events from '@utilities/events'
import createElementFromString from '@utilities/dom-utils/create-element-from-string'
import ScreenDimensions from '@utilities/screen-dimensions'
import Component from '@utilities/store/lib/component'
import store from '@utilities/store'
import DetectTouch from '@utilities/detect-touch'
import ScrollTo from '@utilities/scroll-to'

const STORE_ACCORDION_ITEM_HIDDEN = 'store__accordion-item--hidden'
const HIDDEN_CLASS = 'u-hidden'
const DETAIL_ID_PREFIX = 'store-details-'
const STORE_SELECT_ZOOM_LEVEL = 14
const MOBILE_ZOOM_LEVEL = 10;
const MARKER_ZINDEX_DEFAULT = 0
const MARKER_ZINDEX_ACTIVE = 100
const MARKER_ZINDEX_MOUSEOVER = 150
const JS_HOOK_MAP = '[js-hook-store-locator-map]'
const JS_HOOK_SELECT_STORE_BUTTON = '[js-hook-select-store]'
const JS_HOOK_CALL_STORE_BUTTON = '[js-hook-call-store]'
const JS_HOOK_MAP_SELECTED_STORE = '[js-hook-map-selected-store]'
const JS_HOOK_MAP_SELECTED_STORE_INFO = '[js-hook-map-selected-store-info]'
const JS_HOOK_MAP_SELECTED_STORE_MODAL_CONTENT = '[js-hook-map-selected-modal-content]'
const JS_HOOK_MAP_SELECTED_STORE_MODAL = '[js-hook-map-selected-modal]'
const JS_HOOK_STORE_ITEM = '[js-hook-store-item]'
const STORE_LOCATOR_ITEM_ACTIVE = 'store-locator__item--active'
const JS_HOOK_SELECTED_ITEM_ACTIVE = 'store-locator__selected-content--active'
const JS_HOOK_MAP_TAB = '[js-hook-storelocator-map]'
const JS_HOOK_SHOW_MORE_STORES = '[js-hook-show-more-stores]'
const JS_HOOK_RESET_BOUNDS = '[js-hook-store-locator-reset-bounds-input]'
const JS_HOOK_STORE_LOCATOR_FORM = '[js-hook-store-locator-form]'

class StoreLocatorMap extends Component {
  constructor(element) {
    super({
      store,
      element,
    })

    this.googleMapLoaded = false

    const { mapStylingId, lat, lng, ...data } = this.element.dataset || {}

    // Markers
    this.markers = []
    this.markerSize = ScreenDimensions.isTabletLandscapeAndBigger ? [30, 38] : [21, 27]
    this.markerSizeSm = [21, 27]
    this.markerIcon = data.markerIcon
    this.markerIconHover = data.markerIconHover
    this.markerExperienceIcon = data.markerExperienceIcon
    this.markerExperienceIconHover = data.markerExperienceIconHover
    this.markerIconFlagship = data.markerIconFlagship
    this.markerIconFlagshipHover = data.markerIconFlagshipHover
    this.markerIconShowroom = data.markerIconShowroom
    this.markerIconShowroomHover = data.markerIconShowroomHover
    this.markerIconMonobrand = data.markerIconMonobrand
    this.markerIconMonobrandHover = data.markerIconMonobrandHover
    this.markerIconDesign = data.markerIconDesign
    this.markerIconDesignHover = data.markerIconDesignHover
    this.clustererIcon = data.clustererIcon

    this.map = document.querySelector(JS_HOOK_MAP)
    this.storeItems = [...document.querySelectorAll(JS_HOOK_STORE_ITEM)]
    this.selectedModal = document.querySelector(JS_HOOK_MAP_SELECTED_STORE_MODAL)
    this.selectedModalContent = document.querySelector(JS_HOOK_MAP_SELECTED_STORE_MODAL_CONTENT)
    this.mapTab = document.querySelector(JS_HOOK_MAP_TAB)
    this.showMoreStores = document.querySelector(JS_HOOK_SHOW_MORE_STORES)
    const selectedStoreWrapper = document.querySelector(JS_HOOK_MAP_SELECTED_STORE)

    this.selectedModalState = 0
    this.html = document.querySelector("html")

    this.yDown = null

    this.ui = {
      selectedStoreWrapper,
      selectedStoreInfo:
        selectedStoreWrapper?.querySelector(JS_HOOK_MAP_SELECTED_STORE_INFO) || false,
      selectStoreButton: selectedStoreWrapper?.querySelector(JS_HOOK_SELECT_STORE_BUTTON) || false,
      callStoreButton: selectedStoreWrapper?.querySelector(JS_HOOK_CALL_STORE_BUTTON) || false,
      resetBounds: document.querySelector(JS_HOOK_RESET_BOUNDS) || false
    }

    // Location
    this.mapOptions = {
      mapStylingId,
      zoom: 7,
      lat,
      lng,
    }

    this.bindEvents()
    this.hideSwipeElement()
  }

  static prepareSelectedStoreHtml({ html }) {
    const el = createElementFromString(html)
    const fragment = document.createDocumentFragment()

    const header = document.createElement('div')
    header.classList.add('store__header')

    const elements = [...el.querySelectorAll('.store__header > *')]
    elements.forEach((node) => header.appendChild(node))

    const hoursElement = el.querySelector('.store__hours')
    hoursElement.id = `selected-store-hours`

    fragment.appendChild(header)
    fragment.appendChild(hoursElement)

    return fragment
  }

  /**
   * Resize the map on window resize, the HTML5 canvas
   * doesn't support this otherwise...
   */
  static onWindowResize() {
    google.maps.event.trigger(GoogleMaps.utilities.map, 'resize')
    GoogleMaps.utilities.centerMap(GoogleMaps.utilities.map.getCenter())
  }

  static isReady(state) {
    return state && state.mapsApiReady
  }

  static getTouch (e) {
    return e.changedTouches[0]
  }

  static isStoreType(item, type) {
    const result = JSON.stringify(item).toLowerCase().includes(type)
    return result;
  }

  static zoomMap(zoomLevel) {
    GoogleMaps.utilities.setZoom(zoomLevel || STORE_SELECT_ZOOM_LEVEL);
  }

  hideSwipeElement() {
    if(!DetectTouch.touch) {
      this.selectedModal.style.display = `none`;
    }
  }

  setItemListActive(id) {
    const activeElement = document.querySelector(`.${STORE_LOCATOR_ITEM_ACTIVE}`)
    const element = document.querySelector(`#${id}`);
    const elementIsHidden = element && element.classList.contains(STORE_ACCORDION_ITEM_HIDDEN)

    if (activeElement) {
      activeElement.classList.remove(STORE_LOCATOR_ITEM_ACTIVE)
    }

    if (elementIsHidden) {
      this.showMoreStores.click()
    }

    element.classList.add(STORE_LOCATOR_ITEM_ACTIVE)

    if (ScreenDimensions.isTabletLandscapeAndBigger) {
      ScrollTo.scrollTo(element, 350, 250)
    }

    if (!ScreenDimensions.isTabletLandscapeAndBigger) {
      this.mapTab.click()
      ScrollTo.scrollTo(this.map)
    }

    this.showSelectedItemModal(element)
  }

  showSelectedItemModal(item) {
    if (this.selectedModalContent) {
      this.selectedModalContent.innerHTML = item.innerHTML
      this.selectedModalContent.classList.add(JS_HOOK_SELECTED_ITEM_ACTIVE)
      this.selectedModalState = 1
    }
  }

  /**
   * Bind general events
   */
  bindEvents() {
    if (this.ui.selectStoreButton)
      this.ui.selectStoreButton.addEventListener('click', () => this.selectStore())

    Events.$on(`accordion::opened`, (_, data) => this.onAccordionOpen(data))
    Events.$on(`store::click`, (_, data) => this.onStoreClick(data))
    Events.$on('map::zoom', () => StoreLocatorMap.zoomMap())

    if (this.selectedModal) {
      this.selectedModal.addEventListener('touchstart', e => {
        const firstTouch = StoreLocatorMap.getTouch(e);
        this.html.classList.add('no--scroll');
        this.detectTouch(firstTouch.clientY)
      });

      this.selectedModal.addEventListener('touchend', e => {
        this.itemModalSwipe(e);
      });
    }

    if(this.mapTab) {
      this.mapTab.addEventListener('click', () => {
        StoreLocatorMap.zoomMap(MOBILE_ZOOM_LEVEL);
      })
    }
  }

  itemModalSwipe(e) {
    const offset = 50

    if (!this.yDown) {
      return
    }

    const {
      clientY: yUp
    } = StoreLocatorMap.getTouch(e)

    const yDiff = this.yDown - yUp
    const yDiffAbs = Math.abs(this.yDown - yUp)

    if (Math.max(yDiffAbs) < offset ) {
      return
    }

    if ( yDiff > 0 ){
      this.modalSwipeAnimation(this.selectedModal, 'down')
    } else {
      this.modalSwipeAnimation(this.selectedModal, 'up')
    }
  }

  detectTouch(yDown) {
    this.yDown = yDown
  }

  modalSwipeAnimation(element, direction) {
    if (this.selectedModalState !== 0) {
      // const calculateHeight = (this.selectedModalContent.offsetHeight + 70)

      if (direction === 'up') {
        element.style.transform = `translateY(90%)`
      } else if (direction === 'down') {
        element.style.transform = `translateY(0px)`
      }

      this.html.classList.remove('no--scroll')
    }
  }

  /**
   * When an accordion gets opened, activate and goto marker
   */
  onAccordionOpen({ id }) {
    const marker = this.markers?.[id]

    if (!marker) return

    this.setActiveMarker(marker)
    this.setSelectedStore(id)
    GoogleMaps.utilities.setZoom(STORE_SELECT_ZOOM_LEVEL)
    GoogleMaps.utilities.centerMap(marker.position)
  }

  onStoreClick(id) {
    const marker = this.markers?.[id]

    if (!marker) return

    const thisForm = document.querySelector(JS_HOOK_STORE_LOCATOR_FORM);
    thisForm.setAttribute('data-map-events', 'false');

    this.setActiveMarker(marker)
    this.setSelectedStore(id)
    GoogleMaps.utilities.setZoom(STORE_SELECT_ZOOM_LEVEL)
    GoogleMaps.utilities.centerMap(marker.position)

    this.setItemListActive(id)

    setTimeout(() => {
      thisForm.setAttribute('data-map-events', 'true');
    }, 1000);
  }

  onSearchHandler() {
    if (this.ui.selectedStoreWrapper) this.ui.selectedStoreWrapper.classList.add(HIDDEN_CLASS)
  }

  selectStore() {
    Events.$trigger('store-locator::setStore', { data: { selectedStore: this.selectedStore } })
  }

  setSelectedStore(markerId) {
    const { stores = [] } = store.state

    if (!this.ui.selectedStoreWrapper) return

    this.ui.selectedStoreWrapper.classList.add(HIDDEN_CLASS)
    this.ui.selectedStoreInfo.innerHTML = ''
    this.selectedStore = null

    const id = markerId.replace(DETAIL_ID_PREFIX, '')
    const selectedStore = stores.find(({ ID }) => ID === id)
    if (!selectedStore) return

    this.selectedStore = selectedStore

    if (this.ui.callStoreButton)
      this.ui.callStoreButton.href = selectedStore.phone ? `tel:${selectedStore.phone}` : ''

    this.ui.selectedStoreInfo.appendChild(StoreLocatorMap.prepareSelectedStoreHtml(selectedStore))
    this.ui.selectedStoreWrapper.classList.remove(HIDDEN_CLASS)
  }

  /**
   * Create a Google Maps map
   * @param {Number} zoom - the zoomlevel to init
   * @param {Number} lat - the latitude coordinate to init
   * @param {Number} long - the longitude coordinate to init
   */
  createMap() {
    GoogleMaps.utilities.createMap(
      this.element,
      GoogleMaps.utilities.getMapOptions(this.mapOptions),
    )

    google.maps.event.addListenerOnce(GoogleMaps.utilities.map, 'idle', () => {
      google.maps.event.addDomListener(window, 'resize', () => StoreLocatorMap.onWindowResize())
    })

    this.googleMapLoaded = true
  }

  /**
   * Clear markers, set markers and fit bounds to visible markers
   */
  initMarkers() {
    this.clearMarkers()
    this.setMarkers()
    this.setMapBounds()
  }

  setMapBounds() {
    const { lat, lng } = store.state.location
    const position = new google.maps.LatLng(lat, lng)
    const resetBounds = this.ui.resetBounds.value

    if (resetBounds === 'true') {
      if (Object.keys(this.markers).length > 0) {
        GoogleMaps.utilities.fitBoundsToVisibleMarkers(position)
      } else {
        GoogleMaps.utilities.centerMap(position)
      }
    }
  }

  /**
   * Add markers to the map
   */
  setMarkers() {
    const { stores } = store.state
    if (!stores) return

    const markers = stores.map((storeItem) => this.addMarkerToMap(storeItem))
    GoogleMaps.utilities.addMarkers(markers, this.clustererIcon)
  }

  /**
   * Get the marker options object
   * @param {Object} item - store item object
   */
  getMarkerOptions(item) {
    const isFlagship = StoreLocatorMap.isStoreType(item.storeType, "flagship");
    const isFlagshipStore = StoreLocatorMap.isStoreType(item.storeType, "flagship_store");
    const isMonoBrand = StoreLocatorMap.isStoreType(item.storeType, "monobrand");
    const isShowroom = StoreLocatorMap.isStoreType(item.storeType, "showroom");
    const isDesignSpace = StoreLocatorMap.isStoreType(item.storeType, "flos_design_space");
    let iconURL = this.markerIcon;

    if (isFlagship || isFlagshipStore) {
      iconURL = this.markerIconFlagship;
    } else if (isMonoBrand) {
      iconURL = this.markerExperienceIcon;
    } else if (isShowroom) {
      iconURL = this.markerIconShowroom;
    } else if (isDesignSpace) {
      iconURL = this.markerIconDesign;
    }

    return {
      position: new google.maps.LatLng(item.latitude, item.longitude),
      title: item.name,
      id: DETAIL_ID_PREFIX + item.ID,
      url: item.url,
      isExperienceStore: item.isExperienceStore || false,
      isFlagship: isFlagship || false,
      isMonoBrand: isMonoBrand || false,
      isShowroom: isShowroom || false,
      isDesignSpace: isDesignSpace || false,
      icon: {
        url: iconURL,
        scaledSize: new google.maps.Size(this.markerSizeSm[0], this.markerSizeSm[1]),
      },
    }
  }

  /**
   * Get marker by id
   * @param {id} ID - id in list of markers
   */
  getMarker(id) {
    return this.markers[DETAIL_ID_PREFIX + id]
  }

  /**
   * Set active marker
   * @param {marker} Google maps marker
   */
  setActiveMarker(marker) {
    if (this.currentMarker) {
      this.currentMarker.isActive = false
      this.handleMarkerMouseout(this.currentMarker)
    }

    let iconURL = this.markerIconHover;

    if (marker.isFlagship || marker.isFlagshipStore) {
      iconURL = this.markerIconFlagshipHover;
    } else if (marker.isMonoBrand) {
      iconURL = this.markerExperienceIconHover;
    } else if (marker.isShowroom) {
      iconURL = this.markerIconShowroomHover;
    } else if (marker.isDesignSpace) {
      iconURL = this.markerIconDesignHover;
    }

    marker.setZIndex(MARKER_ZINDEX_ACTIVE)
    marker.setIcon({
      url: iconURL,
      scaledSize: this.scaledMarkerSizeSm,
    })

    marker.isActive = true
    this.currentMarker = marker

    this.setItemListActive(marker.id)
  }

  /**
   * Handle click of marker on map
   * @param {Object} marker - the marker object
   */
  handleMarkerClick(marker) {
    this.setActiveMarker(marker)
    Events.$trigger('store-locator::setActive', { data: { id: marker.id } })
  }

  /**
   * Handle mouseover of marker on map
   * @param {Object} marker - the marker object
   */
  handleMarkerMouseover(marker) {
    let iconURL = this.markerIconHover;

    if (marker.isFlagship || marker.isFlagshipStore) {
      iconURL = this.markerIconFlagshipHover;
    } else if (marker.isMonoBrand) {
      iconURL = this.markerExperienceIconHover;
    } else if (marker.isShowroom) {
      iconURL = this.markerIconShowroomHover;
    } else if (marker.isDesignSpace) {
      iconURL = this.markerIconDesignHover;
    }

    marker.setZIndex(MARKER_ZINDEX_MOUSEOVER)
    marker.setIcon({
      url: iconURL,
      scaledSize: this.scaledMarkerSizeSm,
    })
  }

  /**
   * Handle mouseover of marker on map
   * @param {Object} marker - the marker object
   */
  handleMarkerMouseout(marker) {
    if (marker.isActive) return

    let iconURL = this.markerIcon;

    if (marker.isFlagship || marker.isFlagshipStore) {
      iconURL = this.markerIconFlagship;
    } else if (marker.isMonoBrand) {
      iconURL = this.markerExperienceIcon;
    } else if (marker.isShowroom) {
      iconURL = this.markerIconShowroom;
    } else if (marker.isDesignSpace) {
      iconURL = this.markerIconDesign;
    }

    marker.setZIndex(MARKER_ZINDEX_DEFAULT)
    marker.setIcon({
      url: iconURL,
      scaledSize: this.scaledMarkerSizeSm,
    })
  }

  /**
   * Add a marker of a store to the map
   * @param {Object} item - store item object
   */
  addMarkerToMap(item) {
    if (!this.markers[item.ID]) {
      const options = this.getMarkerOptions(item)
      const marker = GoogleMaps.utilities.createMarker(options)
      this.markers[DETAIL_ID_PREFIX + item.ID] = marker

      // Marker events
      marker.addListener('mouseover', () => this.handleMarkerMouseover(marker))
      marker.addListener('mouseout', () => this.handleMarkerMouseout(marker))
      marker.addListener('click', () => this.handleMarkerClick(marker))
    }

    return this.markers[DETAIL_ID_PREFIX + item.ID]
  }

  clearMarkers() {
    this.markers = []
    if (GoogleMaps.utilities.clusterer) GoogleMaps.utilities.clusterer.clearMarkers()
  }

  initMap() {
    this.scaledMarkerSize = new google.maps.Size(this.markerSize[0], this.markerSize[1])
    this.scaledMarkerSizeSm = new google.maps.Size(this.markerSizeSm[0], this.markerSizeSm[1])

    this.createMap()
    this.initMarkers()
  }

  /**
   * Gets called when store state changes
   */
  stateChanged() {
    const { state, prevState } = store

    if (!StoreLocatorMap.isReady(state)) return

    // Load map view;
    // On firstLoad and no google maps initialized yet
    if (!this.googleMapLoaded) this.initMap()

    if (state.stores !== prevState.stores) {
      this.initMarkers()
      this.onSearchHandler()
    }

    // if (state.stores?.length === 0) GoogleMaps.utilities.setZoom(11)
  }
}

export default StoreLocatorMap
